module.exports = "pegasus/assets/themelp1/small/54.png";